import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { AdminBrandBannerStatus } from '../../enums/admin-brand-banner-status';
import { dateWithOffsetSerializer } from '@web/common';

@jsonObject
export class AdminBrandBannerUpdateRequest {
  @jsonMember(String)
  public readonly url?: Nillable<string>;

  @jsonMember(String)
  public readonly fileId!: Guid;

  @jsonMember(String)
  public readonly smallFileId?: Nillable<Guid>;

  @jsonMember(String)
  public readonly status!: AdminBrandBannerStatus;

  @jsonMember(Date, { serializer: dateWithOffsetSerializer() })
  public readonly visibilityStartDate?: Nillable<Date>;

  @jsonMember(Date, { serializer: dateWithOffsetSerializer() })
  public readonly visibilityEndDate?: Nillable<Date>;

  public constructor(
    private readonly data: {
      fileId: Guid;
      smallFileId?: Nillable<Guid>;
      status: AdminBrandBannerStatus;
      url?: Nillable<string>;
      visibilityStartDate?: Nillable<Date>;
      visibilityEndDate?: Nillable<Date>;
    },
  ) {
    this.fileId = this.data.fileId;
    this.smallFileId = this.data.smallFileId;
    this.status = this.data.status;
    this.url = this.data.url;
    this.visibilityStartDate = this.data.visibilityStartDate;
    this.visibilityEndDate = this.data.visibilityEndDate;
  }
}
